var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "580px",
    height: "580px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "nonzero",
    clipRule: "nonzero",
    viewBox: "0 0 5800 5800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud_download icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "cloud_download icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "curve28",
    fill: "#000000",
    d: "M500 2765c0,524 434,935 954,935l946 0 0 200 -946 0c-629,0 -1154,-501 -1154,-1135 0,-522 278,-903 767,-1077 -35,-737 466,-1312 1199,-1381 52,-4 103,-7 152,-7 482,0 820,209 1112,578 346,-121 734,-77 1025,152 325,256 432,657 376,1056 377,173 569,448 569,869 0,528 -437,945 -961,945l-1139 0 0 -200 1139 0c414,0 761,-327 761,-745 0,-376 -178,-579 -517,-716l-77 -31 16 -80c66,-348 0,-713 -290,-941 -256,-201 -602,-222 -898,-97l-72 30 -46 -62c-260,-350 -549,-558 -998,-558 -49,0 -93,2 -134,6 -660,62 -1075,587 -1013,1243l7 82 -78 23c-443,133 -700,443 -700,911zm2500 -265l0 2659 829 -830 142 142 -1000 1000 -71 70 -71 -70 -1000 -1000 142 -142 829 830 0 -2659 200 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud_download.24d332cbcd8d37cf6660f57c5d8c2c32.svg";
export { ForwardRef as ReactComponent };